import versionText from "../../version.txt"; // Adjust the path as necessary
import configs from "@/configs.json";
export const ROUTES = {
  LOGIN: "/login",
  REGISTER: "/register",
  GOOGLE_AUTH_CALLBACK: "/auth/google/callback",
  TOPIC_QUESTION: "/cms/topic-question",
  CATEGORY_ASPECT: "/cms/category-aspect",
  QUESTION_IDEA: "/cms/question-idea/:id",
  USERS: "/cms/users",
  GROUPS: "/cms/groups",
  CHALLENGE_CMS: "/cms/challenge",
  LANDING: "/intro",
  LEARN: "/learn",
  LEARN_TOPIC: "/learn/topic",
  LEARN_GROUP_PART2: "/learn/group-part2",
  LEARN_QUESTION_PART2: "/learn/group-part2/:groupId",
  LEARN_GUIDED_QUESTION_PART2: "/learn/question-part2/:questionId",
  LEARN_QUESTION: "/learn/question/:topicId",
  LEARN_CATEGORY: "/learn/category/:topicId/:questionId",
  LEARN_ASPECT: "/learn/aspect/:topicId/:questionId/:categoryId",
  LEARN_IDEA: "/learn/idea/:topicId/:questionId/:categoryId/:aspectId",
  ANSWER: "/answer/:topicId/:questionId/:categoryId/:aspectId",
  DASHBOARD: "/dashboard",
  CHALLENGE: "/challenge",
  PROFILE: "/profile",
  ACCOUNT: "/account",
  WORDBANK: "/vocabulary",
  WORDBOOK: "/wordbook/:wordbookId",
  ASPECT_ALL_CMS: "/cms/aspect-all",
  PERSONALIZED_CMS: "/cms/personalized",
  AI_CALL_STATIS_CMS: "/cms/ai-call-statis",
  GRAMMAR_CMS: "/cms/grammar",
  CMS_AI_TESTER: "/cms/ai-tester",
  QUESTION_PART2: "/cms/question-part2",
  QUESTION_TYPE_CMS: "/cms/question-type",
  CHOOSE_ORIENTED_LEARNING: "/learn/choose-oriented-learning",
  LEARN_QUESTION_TYPE: "/learn/question-type",
  LEARN_QUESTION_TYPE_BY_CAT: "/learn/question-type/:questionCategoryId",
  LEARN_QUESTION_TYPE_LIST_QUESTION: "/learn-question-type/:questionTypeId/list-question",
  LEARN_TOPIC_QUESTION: "/learn/topic-question",
  LEARN_QUESTION_PAGE: "/learn/by-question/:questionId",
  LEARN_TOPIC_QUESTION_TYPE: "/learn/topic-question-type",
  ANSWER_QUESTION: "/answer-question/:questionId",
  LEARN_PART_2: "/learn/part-2",
  LEARN_PRACTICE_SPEAKING: "/learn/practice-speaking/:questionId",
  TEACHER_DASHBOARD: "/teacher/dashboard",
  TEACHER_CLASS: "/teacher/class",
  TEACHER_CLASS_DETAIL: "/teacher/class/:classId",
  TEACHER_STUDENTS: "/teacher/students",
  TEACHER_WORDBANK: "/teacher/wordbank",
  TEACHER_VOCA_ASSIGNMENT: "/teacher/voca-assignment",
  // Submission
  STUDENT_VOCA_SUBMISSTION: "/student/voca-submission/:assignmentId",
  TEACHER_VOCA_SUBMISSION_TRACKING: "/teacher/voca-submission-tracking/:assignmentId",

  STUDENT_MY_CLASS: "/student/my-class",

  CMS_LEARN_VOCA: "/cms/clearn-voca",
  CMS_LEARN_VOCA_QUESTION: "/cms/clearn-voca/:questionId",

  CMS_WORDBANK: "/cms/wordbank",
  CMS_WORKBOOK: "/cms/workbook/:wordbookId",
  CMS_QUESTION_WORDBOOK: "/cms/question-wordbook/:questionId",

  // new flow
  COURSE_PAGE: "/course",
  COURSE_DETAIL: "/course/:id",

  // cms course
  CMS_COURSE: "/cms/course",
  CMS_DETAIL_COURSE: "/cms/course/:id",
  CMS_TIMELINE_LIBRARY: "/cms/timeline-library/:questionId",
  CMS_ADMIN_DASHBOARD: "/cms/admin-dashboard",
  CMS_PRONUNCIATION_HISTORY: "/cms/pronunciation-history",

  // Payment & Subscription
  UPGRADE: "/upgrade",
  PAYMENT: "/payment/:packageId",
  SUBSCRIPTION: "/subscription",
  CMS_PACKAGE: "/cms/package",
  CMS_TRANSACTION: "/cms/transactions",
  CMS_WEBHOOK_LOG: "/cms/webhook-log",
  CMS_EMAIL_TEMPLATE: "/cms/email-templates",
  USER_STATS: "/cms/users/stats/:id",
  CMS_ASPECT_STRUCTURES: "/cms/aspect-structures",
  VOCABULARY: "/vocabulary",
  CMS_FORECAST: "/cms/forecast",
  ASSESSMENT: "/assessment",
  ASSESSMENT_PRONUNCIATION: "/assessment/pronunciation",
  ASSESSMENT_QUESTION: "/assessment/question",
  CMS_SPEECHACE_BILLING: "/cms/speechace-billing",
  CMS_AI_BILLING: "/cms/ai-billing",

  // Systematic Grammar Library (Grammar Books)
  CMS_GRAMMAR_BOOKS: "/cms/grammar-books",
  LEARN_GRAMMAR: "/learn/grammar",
  LEARN_GRAMMAR_DETAIL: "/learn/grammar/:slug",

  // Student assignments
  STUDENT_ASSIGNMENTS: "/student/assignments",
  STUDENT_ASSIGNMENT_DETAIL: "/student/assignments/:id",
  // IELTS Exams
  CMS_IELTS_EXAMS: "/cms/ielts-exams",
  CMS_IELTS_SUBMISSIONS: "/cms/ielts-submissions",
  CMS_WRITING_QUESTIONS: "/cms/writing-questions",
  CMS_SUPPLEMENTARY_EXERCISES: "/cms/supplementary-exercises",
  CMS_CAMBRIDGE_FLASHCARDS: "/cms/cambridge-flashcards",
  CMS_COMMON_STRUCTURES: "/cms/common-structures",
  CMS_PROMPT_MANAGEMENT: "/cms/prompt-management",
  CMS_USER_REPORTS: "/cms/user-reports",
  IELTS_EXAMS: "/ielts-exams",
  IELTS_EXAMS_TAKE: "/ielts-exams/take/:id",
  IELTS_EXAMS_REVIEW: "/ielts-exams/review/:submissionId",
  IELTS_EXAMS_READING: "/ielts-exams/reading",
  READING_PRACTICE: "/ielts-exams/reading/practice",
  IELTS_EXAMS_LISTENING: "/ielts-exams/listening",
  IELTS_EXAMS_BASIC_LISTENING: "/ielts-exams/basic-listening",
  LISTENING_PRACTICE: "/ielts-exams/listening/practice",
  IELTS_EXAMS_WRITING: "/ielts-exams/writing",
  SPEAKING_REACTION_TEST: "/speaking/reaction-test",
};

export const KeyTokenName = "ffl_token";

export const appVersion = `Version: ${(await fetch(versionText).then((res) => res.text())) || "0.0.1"}`;

export const BASE_DICT_SOUND_US = import.meta.env.BASE_DICT_SOUND_US || configs.BASE_DICT_SOUND_US;
export const BASE_DICT_SOUND_UK = import.meta.env.BASE_DICT_SOUND_UK || configs.BASE_DICT_SOUND_UK;
export const CLOUDFLARE_PUBLIC_URL = import.meta.env.VITE_CLOUDFLARE_PUBLIC_URL || configs.CLOUDFLARE_PUBLIC_URL || "";

export const INIT_GRAMMAR_TOPICS = [
  "Hiện tại đơn",
  "Hiện tại tiếp diễn",
  "Quá khứ đơn",
  "Quá khứ tiếp diễn",
  "Hiện tại hoàn thành",
  "Hiện tại hoàn thành tiếp diễn",
  "Quá khứ hoàn thành",
  "Quá khứ hoàn thành tiếp diễn",
  "Tương lai đơn",
  "Tương lai tiếp diễn",
  "Be going to",
  "Giới từ chỉ địa điểm",
  "Giới từ chỉ thời gian",
  "Câu bị động",
  "Danh từ đếm được",
  "Danh từ không đếm được",
  "Mạo từ",
  "Đại từ",
  "Mệnh đề quan hệ",
  "Động từ khuyết thiếu",
  "Mệnh đề chỉ mục đích",
  "Mệnh đề chỉ nguyên nhân",
  "Mệnh đề chỉ lí do",
  "Mệnh đề chỉ kết quả",
  "Mệnh đề chỉ sự nhượng bộ",
  "Liên từ",
  "So sánh hơn",
  "So sánh hơn nhất",
  "Câu điều kiện",
  "Wish/ If only",
  "Gerund and Infinitive",
];

export enum LLMTypes {
  add_connector = "add_connector",
  repharse = "repharse",
  adjust_word_limit = "adjust_word_limit",
  grammar_analysis = "grammar_analysis",
  suggest_vocabulary = "suggest_vocabulary",
  sort_idea = "sort_idea",
  search_dict = "search_dict",
  transcribe = "transcribe",
  evaluate = "evaluate",
  word_match = "word_match",
  suggest_answer = "suggest_answer",
  speechace = "speechace",
}

export const INIT_LLM_ENERGY = {
  limitQuotaEnergyByDay: 1000,
  types: {
    [LLMTypes.add_connector]: 20, // claude-3-7-sonnet
    [LLMTypes.repharse]: 20, // claude-3-7-sonnet
    [LLMTypes.adjust_word_limit]: 20, // claude-3-haiku => claude-3-7-sonnet
    [LLMTypes.grammar_analysis]: 20, // gpt-4 => claude-3-7-sonnet
    [LLMTypes.suggest_vocabulary]: 8, // llama-v3
    [LLMTypes.sort_idea]: 8, // llama-v3
    [LLMTypes.search_dict]: 8, // llama-v3
    [LLMTypes.transcribe]: 8, // nova-2
    [LLMTypes.evaluate]: 8, // llama-v3
  },
};

export enum EQuestionNumber {
  QUESTION_PART_1 = "P1",
  QUESTION_PART_2 = "P2",
  QUESTION_PART_3 = "P3",
}

export enum VocaType {
  noun = "noun",
  verb = "verb",
  adjective = "adjective",
  adverb = "adverb",
  phrases = "phrases",
  collocation = "collocation",
  idiom = "idiom",
}

export const colorByLevel = {
  A1: "#90EE90",
  A2: "#ADD8E6",
  B1: "#FFD700",
  B2: "#FFA500",
  C1: "#ff0000",
  C2: "#800080",
};

export const GRAMMAR_GROUP_MAPPING: Record<string, string> = {
  a1: "NHÓM A1 — Căn bản (Band 3.5–4.5)",
  a2: "NHÓM A2 — Sơ cấp (Band 4.5–5.5)",
  b1: "NHÓM B1 — Trung cấp (Band 5.0–6.5)",
  "b1-b2": "NHÓM B1–B2 (Band 5.5–7.0)",
  b2: "NHÓM B2 — Khá (Band 6.5–7.5)",
  c1: "NHÓM C1 — Cao cấp (Band 7.0–8.0+)",
};

export * from "./aspect-media";
